interface SearchBarProps {
  onClick: () => void
  compact?: boolean
}

export function SearchBar({ onClick, compact = false }: SearchBarProps) {
  return (
    <button
      className={`search-bar ${compact ? 'compact' : ''}`}
      onClick={onClick}
      aria-label="Open search"
    >
      <span className="search-bar-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8"/>
          <path d="M21 21l-4.35-4.35"/>
        </svg>
      </span>
      <span className="search-bar-text">Search...</span>
    </button>
  )
}
